module.exports = function (app) {
    app.directive('groupEntitlements', function () {
        return {
            template: require('directives/planAdmin/groupEntitlements.html'),
            restrict: 'A',
            controller: ['$scope', 'employerUtility', function($scope,employerUtility){
                var populateTableData;
                $scope.groupTableObj = {

                    order: 'groupNumber',
                    orderBy: 'groupNumber',
                    reverse: true,
                    selectAllRows: false,
                    rowSelectionEnabled: true,

                    titles: [
                        {
                            name: "Group Number",
                            dataKey: "groupNumber",
                            checkbox: true
                        },
                        {
                            name: "Employee Data",
                            dataKey: "employeeData"
                        },
                        {
                            name: "Spending Account",
                            dataKey: "spendingAccount"
                        }
                    ],

                    pagination: {
                        itemsPerPage: 1000,
                        page: 1
                    },

                    groupAccessArray : []

                };

                populateTableData=function(){
                    var filter=$scope.groupTableObj.groupAccessArray.filterBy;
                    $scope.groupTableObj.groupAccessArray = [];
                    $scope.groupTableObj.groupAccessArray.filterBy=filter;
                    if ($scope.groupLevelEntitlements) {
                        for (var group in $scope.groupLevelEntitlements) {
                            if ($scope.groupLevelEntitlements.hasOwnProperty(group)) {
                                var groupObj = {};
                                var currentObj = $scope.groupLevelEntitlements[group];
                                groupObj.groupNumber = group;
                                groupObj.employeeData = currentObj['Employee Data'] || 'None';
                                groupObj.spendingAccount = currentObj['Spending Account'] || 'None';
                                //for ibc medicare
                                groupObj.showCheckBox=currentObj['Medicare']==='Y'?false:true;

                                $scope.groupTableObj.groupAccessArray.push(groupObj);
                            }


                        }
                    }
                };

                $scope.$watch("groupLevelEntitlements",function(newValue,oldValue){
                    populateTableData();
                });

                $scope.$watch("tableDataModified",function(newValue,oldValue){
                    if(newValue!=oldValue){
                        for(var i=0;i<$scope.groupTableObj.groupAccessArray.length;i++){
                            if($scope.groupTableObj.groupAccessArray[i].selected){
                                var key=$scope.groupTableObj.groupAccessArray[i].groupNumber;
                                var employeeDataValue=$scope.groupEntitlement.enrollment === ''
									? $scope.groupLevelEntitlements[key] && $scope.groupLevelEntitlements[key]['Employee Data']
								   	: $scope.groupEntitlement.enrollment;
                                var spendingAccountValue=$scope.groupEntitlement.spendingAccount === ''
									? $scope.groupLevelEntitlements[key] && $scope.groupLevelEntitlements[key]['Spending Account']
									: $scope.groupEntitlement.spendingAccount;
                                $scope.groupTableObj.groupAccessArray[i].employeeData=employeeDataValue;
                                $scope.groupTableObj.groupAccessArray[i].spendingAccount=spendingAccountValue;
                                $scope.groupLevelEntitlements[key]['Employee Data'] = employeeDataValue;
                                $scope.groupLevelEntitlements[key]['Spending Account'] =spendingAccountValue;
                            }
                            $scope.groupTableObj.groupAccessArray[i].selected=false;

                        }
                        $scope.groupsModified=true;
                        $scope.groupTableObj.selectAllRows=false;
                    }
                });

                $scope.$watch("groupTableObj.selectAllRows",function(newValue,oldValue){
                    if(oldValue!=newValue){
                        var filter=$scope.groupTableObj.groupAccessArray.filterBy;
                        for(var index=0; index<$scope.groupTableObj.groupAccessArray.length;index++){
                            var key= $scope.groupTableObj.groupAccessArray[index].groupNumber;
                            if(key && ((filter && (key.indexOf(filter)>=0 || filter.trim()==="")) || !filter)&&$scope.groupLevelEntitlements[key]['Medicare']!=='Y'){
                                $scope.groupTableObj.groupAccessArray[index].selected=$scope.groupTableObj.selectAllRows;
                            }
                        }
                    }
                },true);

            }
            ]
        };
    });
};
